import {createSignal} from '@pexip/signal';
import type {ParticipantID, RoomID} from '@pexip/infinity';

export const openDTMFModalSignal = createSignal<
    {participantUuid?: ParticipantID; roomId?: RoomID} | undefined
>({
    name: 'meeting:open-dtmf-modal',
});

export const openPinModalSignal = createSignal({
    name: 'meeting-open-pin-modal',
});

export const openFeccGwModalSignal = createSignal({
    name: 'meeting-open-fecc-gw-modal',
});

export const openLiveCaptionsLanguageModalSignal = createSignal({
    name: 'meeting-open-live-captions-language-modal',
});

export const userInitiatedDisconnectSignal = createSignal({
    name: 'user-initiated-disconnect-signal',
});

export const participantSearchQuerySignal = createSignal<string>({
    name: 'meeting:participant-search-query',
});
